(() => {
  if (customElements.get('akbar-custom-size')) return;

  class CustomSizeForm extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section');
      this.fields = this.querySelector('.CustomSize__Fields');
      if (!this.scope || !this.fields) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.scope.addEventListener('change', this.schedule, options);
      this.scope.addEventListener('click', this.schedule, options);
      this.scope.addEventListener('variant:change', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['checked', 'class', 'value']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    selectedSize() {
      const easify = [...this.scope.querySelectorAll(
        '.easify-product-options input[type="radio"][name]'
      )].filter(input => /,Size$/i.test(input.name));
      if (easify.length) return easify.find(input => input.checked)?.value;
      const position = Number(this.dataset.sizePosition);
      if (!position) return '';
      const radio = this.scope.querySelector(`input[data-option-position="${position}"]:checked`);
      const popover = this.scope.querySelector(
        `.Popover__Value.is-selected[data-option-position="${position}"]`
      );
      return radio?.labels?.[0]?.textContent.trim() || radio?.value || popover?.dataset.value || '';
    }

    sync() {
      const custom = /^custom(?: size)?(?:\s|$)/i.test((this.selectedSize() || '').trim());
      this.fields.hidden = !custom;
      // Preserve entered values while excluding measurements from standard-size purchases.
      this.fields.disabled = !custom;
      // Prestige's serializer checks each control's disabled property, not its fieldset.
      this.fields.querySelectorAll('input, textarea').forEach(input => { input.disabled = !custom; });
    }
  }

  customElements.define('akbar-custom-size', CustomSizeForm);
})();

